export default __webpack_public_path__ + "static/media/Believer's Sandals of Shimmering Light.98a48bf7.jpg";